(function() {
  'use strict';
  
  //console.log('🎯 Filtro disponibilidade: iniciado');
  
  // Função para modificar a URL antes da submissão AJAX
  function modifyFilterUrl(originalUrl) {
    if (!originalUrl) return originalUrl;
    
    try {
      const urlObj = new URL(originalUrl, window.location.origin);
      
      // Se já tem disponibilidade, mantém
      if (urlObj.searchParams.has('filter.v.availability')) {
        return urlObj.href;
      }
      
      // Adiciona disponibilidade
      urlObj.searchParams.set('filter.v.availability', '1');
      //console.log('✅ URL modificada:', urlObj.href);
      return urlObj.href;
    } catch (e) {
      //console.log('Erro ao modificar URL:', e);
      return originalUrl;
    }
  }
  
  // Interceptar o clique no botão "Aplicar" do drawer
  document.addEventListener('click', function(e) {
    // Botão "Ver produtos" ou "Aplicar" no drawer
    const applyButton = e.target.closest('.mobile-facets__button, .mobile-facets__button--apply, button[type="submit"]');
    if (!applyButton) return;
    
    const drawer = applyButton.closest('.mobile-facets, .facets__form, .js-filter');
    if (!drawer) return;
    
    //console.log('🔘 Botão aplicar clicado');
    
    // Pega todos os checkboxes marcados
    const checkboxes = drawer.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked');
    const checkedValues = [];
    checkboxes.forEach(cb => {
      checkedValues.push({
        name: cb.name,
        value: cb.value
      });
    });
    
    //console.log('📦 Filtros selecionados:', checkedValues);
    
    // Constrói a URL base
    let baseUrl = window.location.pathname;
    let params = new URLSearchParams(window.location.search);
    
    // Adiciona disponibilidade (se não existir)
    if (!params.has('filter.v.availability')) {
      params.set('filter.v.availability', '1');
    }
    
    // Atualiza os parâmetros com os checkboxes marcados
    checkedValues.forEach(filter => {
      // Para checkboxes, precisamos adicionar múltiplos valores
      if (filter.name) {
        // Remove valores antigos desse filtro
        params.delete(filter.name);
        
        // Adiciona todos os valores marcados para este nome
        const allCheckedForName = checkedValues
          .filter(f => f.name === filter.name)
          .map(f => f.value);
        
        allCheckedForName.forEach(value => {
          params.append(filter.name, value);
        });
      }
    });
    
    const newUrl = baseUrl + '?' + params.toString();
    //console.log('🔄 Nova URL:', newUrl);
    
    // Previne o comportamento padrão do botão
    e.preventDefault();
    e.stopPropagation();
    
    // Redireciona
    window.location.href = newUrl;
  }, true); // Captura no início do evento
  
  // Método alternativo: interceptar o formulário antes dele ser processado pelo JS do tema
  const originalFetch = window.fetch;
  window.fetch = function() {
    const url = arguments[0];
    const options = arguments[1] || {};
    
    // Verifica se é uma requisição de filtros
    if (typeof url === 'string' && (url.includes('/collections/') || url.includes('/search'))) {
      if (!url.includes('filter.v.availability') && !options.url?.includes('filter.v.availability')) {
        //console.log('🌐 Interceptando fetch:', url);
        
        // Modifica a URL para incluir disponibilidade
        let newUrl = url;
        try {
          const urlObj = new URL(url, window.location.origin);
          if (!urlObj.searchParams.has('filter.v.availability')) {
            urlObj.searchParams.set('filter.v.availability', '1');
            newUrl = urlObj.href;
            //console.log('✅ Fetch URL modificada:', newUrl);
          }
        } catch (e) {}
        
        // Chama o fetch original com a URL modificada
        return originalFetch.call(this, newUrl, options);
      }
    }
    
    return originalFetch.apply(this, arguments);
  };
  
  // Também intercepta o history.pushState que o tema pode usar
  const originalPushState = history.pushState;
  history.pushState = function() {
    const url = arguments[2];
    if (url && (url.includes('/collections/') || url.includes('/search'))) {
      if (!url.includes('filter.v.availability')) {
        //console.log('📜 Interceptando pushState:', url);
        
        try {
          const urlObj = new URL(url, window.location.origin);
          if (!urlObj.searchParams.has('filter.v.availability')) {
            urlObj.searchParams.set('filter.v.availability', '1');
            arguments[2] = urlObj.pathname + urlObj.search + urlObj.hash;
            //console.log('✅ pushState modificado:', arguments[2]);
          }
        } catch (e) {}
      }
    }
    return originalPushState.apply(this, arguments);
  };
  
  //console.log('✅ Filtro disponibilidade: pronto (modo interceptação total)');
})();